import { Chip, ChipProps } from '@mui/material';
import { green, grey, indigo, lightBlue, red, teal } from '@mui/material/colors';
import { SystemStyleObject } from '@mui/system';
import React from 'react';
import { AssessmentScore, ExerciseSummary, Simulation, SimulationStatus } from '../types';

export type TypeChipProps = Omit<ChipProps, 'sx'> & {
  sx?: SystemStyleObject;
  type?: ExerciseSummary['simulatorType'] | Simulation['status'] | 'assigned' | number | string;
};

// TODO: move these colors to theme palette so that we can set them via `color` prop (eg. "chip.cloud").
// This way we can support outlined variant as well.
const backgroundColorMap = type =>
  ({
    Cloud: indigo[50],
    Site: green[50],
    [SimulationStatus.Completed]: lightBlue[50],
    [SimulationStatus.Failed]: red[100],
    [SimulationStatus.Passed]: teal[50],
    [SimulationStatus.Ongoing]: indigo[50],
    [SimulationStatus.NotStarted]: grey[100],
    [AssessmentScore.Negative]: red[100],
    [AssessmentScore.Positive]: teal[100],
  }[type]);

const foregroundColorMap = type =>
  ({
    [AssessmentScore.Negative]: red[400],
    [AssessmentScore.Positive]: teal[400],
  }[type]);

const TypeChip = ({ type, sx = {}, ...props }: TypeChipProps) => (
  <Chip
    label={type}
    sx={{
      backgroundColor: backgroundColorMap(type),
      color: foregroundColorMap(type),
      textTransform: 'capitalize',
      ...sx,
    }}
    {...props}
  />
);

export const SquareChip = props => <TypeChip sx={{ borderRadius: '4px' }} {...props} />;

export default TypeChip;
